import BottomDrawer from "./index";
import { vw } from "../../../lib/utils/responsiveUtils";
import { cn } from "../../../lib/utils/cn";
import type { ScoreType } from "../../../types/score.types";

interface ScoreTypeDrawerProps {
  open: boolean;
  onClose: () => void;
  selectedType?: ScoreType;
  onSelect: (type: ScoreType) => void;
}

export default function ScoreTypeDrawer({
  open,
  onClose,
  selectedType,
  onSelect,
}: ScoreTypeDrawerProps) {
  const options: { key: ScoreType; label: string; icon?: string }[] = [
    { key: "all", label: "전체" },
    { key: "NORMAL", label: "일반 스코어", icon: "/icons/ic-flag.webp" },
    {
      key: "TOURNAMENT",
      label: "대회 스코어",
      icon: "/icons/ic-tournament-team.webp",
    },
  ];

  return (
    <BottomDrawer open={open} onClose={onClose}>
      <div className="pt-[35px]">
        {options.map((opt) => (
          <button
            key={opt.key}
            className={cn(
              "relative w-full flex items-center justify-center border rounded-[10px] p-[15px] mb-[10px]",
              selectedType === opt.key ? "border-[#222]" : "border-[#e6e6e6]",
            )}
            onClick={() => {
              onSelect(opt.key);
              onClose();
            }}
          >
            <div className="flex items-center justify-center gap-[10px]">
              {opt.icon && (
                <img className="size-4" src={opt.icon} alt={opt.label} />
              )}
              <span className="text-[#222] font-bold text-center">
                {opt.label}
              </span>
            </div>

            {/* 선택 동그라미 */}
            <div
              className={cn(
                "absolute right-[15px] w-[20px] h-[20px] rounded-full border flex items-center justify-center",
                selectedType === opt.key
                  ? "border-[#222] bg-[#222]"
                  : "border-[#e6e6e6]",
              )}
            >
              {selectedType === opt.key && (
                <div
                  className="bg-[#fff] rounded-full"
                  style={{ width: vw(7), height: vw(7) }}
                />
              )}
            </div>
          </button>
        ))}
      </div>
    </BottomDrawer>
  );
}
